import React from "react";
import { useData, useDataValue } from "../hooks/useData";
import { closestIndex } from "../utils/dom";


export function Radio<T>(props: {
    disabled?: boolean;

    className?: string;

    prop: string;

    options: T[],

	verticalLayout?: boolean,
	alignTop?: boolean,

    getValue: (item: T) => string;
    getDisplay: (item: T, selected: boolean) => any;
	getSubtitle?: (item: T) => any,

    onChange?: (value: any) => void;
}) {

	const data = useData();
	const value = useDataValue(data, props.prop);

    function getValue(item: any) {
        if (props.getValue) {
            return props.getValue(item);
        } else {
            return item.value;
        }
    }

	var selectedItem = null;

    function handleClick(e: any) {
        if (disabled) return;

        const index = closestIndex(e.target, ".option");
        if (index < 0 || index >= props.options.length) return;
        
        const option = props.options[index];

        if (props.onChange) {
            props.onChange(getValue(option));
        }

		data.setValue(props.prop, getValue(option));
    }

    const {
        className,
        disabled,
        getDisplay,
    } = props;

    const options = [];
    if (props.options) {
        for(var i=0;i<props.options.length;i++) {
            const option = props.options[i];
            
            // NOTE: don't want precise comparison
            // e.g. 1 == "1" is ok
            /* eslint-disable */
            const selected = (getValue(option) == value);

			if (selected) {
				selectedItem = option;
			}
            /* eslint-enable */
           
			var circle = null;
			//if (props.verticalLayout) {
				var innerCircle = selected ? <div className="inner-circle" /> : null;
				circle = <div className="circle">{innerCircle}</div>;
			//}
				
			const subtitle = props.getSubtitle ? 
				<div className="subtitle">{props.getSubtitle(option)}</div>
				: undefined;

            options.push(
                <div key={i}>
					<div className={"option" + (selected ? " is-selected" : "")} data-index={i}>
						{circle}
						{/* {tick} */}
						{getDisplay(option, selected)}
					</div>
					{subtitle}
                </div>
            );
        }
    }

    return (
        <div
            className={[
				className, 
				"flex form-control radio", 
				disabled ? "disabled" : null,
				props.verticalLayout ? "vert align-start" : "horiz gap-5",
				props.alignTop ? "align-top" : null,
			].join(" ")}
            onClick={handleClick}
            tabIndex={0}
        >
            {options}
        </div>

    );


}

